<ion-app>
  <ion-router-outlet #nav [swipeGesture]="false" (window:orientationchange)="orientationChange()"></ion-router-outlet>
  @if (isLandscapeMode) {
  <div class="landscape-wrapper">
    <h1 class="change-device-orientation">{{'LendingPage.rotate_device' | translate}}</h1>
  </div>
  }
  <div id="typeFormLS" class="typeFormLS"></div>
</ion-app>

@if (holdingMessage$ | async) {
}
<!-- @if (defaultHomeCard$ | async) {
} -->

<!--Side Panel Content-->
<div class="side-panel-content">

  <p>{{'LendingPage.lending-text'| translate }}</p>
</div>
